module.exports = __webpack_public_path__ + "cc526e1a063b89da1f069d7b7d295be5.jpg";